module.exports = __webpack_public_path__ + "static/Dominique-d10437fd7046e4759191f7bd69f86634.png";